"use client";

import { useEffect, useState } from "react";
import posthog from "posthog-js";

interface PricingExperimentProps {
  children: React.ReactNode;
}

export default function PricingExperiment({ children }: PricingExperimentProps) {
  const [showPricing, setShowPricing] = useState(true);

  useEffect(() => {
    // Wait for feature flags to be loaded before checking
    posthog.onFeatureFlags(() => {
      // Feature flags are guaranteed to be available at this point
      const experimentResult = posthog.getFeatureFlag('pricing-data');
      // setShowPricing(experimentResult === 'test');
      setShowPricing(true);
    });
  }, []);

  if (!showPricing) {
    return null;
  }

  return <>{children}</>;
} 